import React, { useEffect, useState, useContext, Fragment } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  ListItemButton,
  ListItem,
  List,
  ListItemText,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { LuView } from "react-icons/lu";
import DeleteIcon from "@mui/icons-material/Delete";

//Srcs
import "../Style/pagestyle.scss";
import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import FooterPagination from "../Components/Include/FooterPagination";
import CreateSupplier from "../Components/Supplier/CreateSupplier";
import SupplierAction from "../Components/Supplier/SupplierAction";
import { GET_SUPPLIER_WITH_PAGINATION } from "../Schema/Supplier";
import { SelectExpenseGroup } from "../Components/Include/DynamicSelect";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function SetUpSupplier() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);

  const { refetch } = useQuery(GET_SUPPLIER_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      // pagination: true,
    },
    onCompleted: ({ getSupplierPagination }) => {
      // console.log("getSupplierPagination", getSupplierPagination);
      setTableData(getSupplierPagination?.data);
      setPaginationData(getSupplierPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const [openCopy, setOpenCopy] = React.useState(false);

  const handleClickToCopy = () => {
    setOpenCopy(true);
  };

  const handleCloseCopy = (e) => {
    setOpenCopy(false);
  };

  const handleLimit = (e) => {
    setLimit(e.target.value);
    // console.log("e", e);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  const colors = ["#50C878", "#FFA62F", "#da2328", "#ea2877"];

  useEffect(() => {
    refetch();
  }, []);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">{t("page_setting")}</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">{t("page_supplier")}</Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              {t("page_supplier")}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={4} lg={3}>
            <Typography className="search-head-title">
              {t("thead_search_name")}
            </Typography>
            <TextField
              placeholder={t("search")}
              size="small"
              className="search-field"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={8} lg={9}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>

              <CreateSupplier
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell className="header-title-start" width="5%">
                  {t("no")}
                </TableCell>
                <TableCell className="header-title" width="15%">
                  {t("thead_name")}
                </TableCell>
                <TableCell className="header-title" width="13%">
                  {t("thead_telephone")}
                </TableCell>
                <TableCell className="header-title" width="22%" align="center">
                  Bank account
                </TableCell>
                <TableCell className="header-title" width="20%">
                  {t("thead_address")}
                </TableCell>
                <TableCell className="header-title" width="15%">
                  {t("thead_remark")}
                </TableCell>
                <TableCell className="header-title-end" width="10%"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody>
                <TableRow className="body-row">
                  <TableCell
                    colSpan={7}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={7} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start" width="5%">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell" width="15%">
                              {row?.name}
                            </TableCell>
                            <TableCell className="body-cell" width="13%">
                              {row?.tell}
                            </TableCell>
                            <TableCell className="body-cell" width="22%">
                              <Accordion
                                disableGutters
                                elevation={0}
                                sx={{ borderBottom: "0px !impoortant" }}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                                >
                                  {/* <Stack direction="row" spacing={1}>
                                    {row?.bankAccounts?.map(
                                      (rowaccoud, index) => (
                                        <ListItem
                                          key={index}
                                          sx={{
                                            margin: "0px ",
                                            padding: "0px !important",
                                          }}
                                        >
                                          <ListItemText
                                            className="bank-name"
                                            sx={{ color: colors[index] }}
                                          >
                                            {rowaccoud?.name}
                                          </ListItemText>
                                        </ListItem>
                                      )
                                    )}
                                  </Stack> */}
                                  <IconButton aria-label="delete">
                                    <LuView color="#50C878" />
                                  </IconButton>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <List className="list-account">
                                    {row?.bankAccounts?.map(
                                      (rowaccoud, index) => (
                                        <ListItem key={index}>
                                          <ListItemText>
                                            {rowaccoud?.name}
                                          </ListItemText>
                                          <CopyToClipboard
                                            text={rowaccoud?.accountNumer}
                                            // onCopy={() => {
                                            //   console.log("first");
                                            // }}
                                          >
                                            <Typography>
                                              {" : "}
                                              <Button
                                                size="small"
                                                className="account-number"
                                                onClick={handleClickToCopy}
                                              >
                                                {rowaccoud?.accountNumer}
                                              </Button>
                                            </Typography>
                                          </CopyToClipboard>
                                          <Snackbar
                                            open={openCopy}
                                            autoHideDuration={500}
                                            onClose={handleCloseCopy}
                                            anchorOrigin={{
                                              vertical: "top",
                                              horizontal: "center",
                                            }}
                                            top
                                          >
                                            <MuiAlert
                                              // onClose={handleCloseCopy}
                                              severity="success"
                                              sx={{
                                                width: "100%",
                                                color: "rgb(34 197 94)",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Copied!
                                            </MuiAlert>
                                          </Snackbar>
                                          <ListItemText>
                                            {rowaccoud?.remark
                                              ? " , " + rowaccoud?.remark
                                              : ""}
                                          </ListItemText>
                                        </ListItem>
                                      )
                                    )}
                                  </List>
                                </AccordionDetails>
                              </Accordion>
                            </TableCell>
                            <TableCell className="body-cell" width="20%">
                              {row?.address}
                            </TableCell>
                            <TableCell className="body-cell" width="15%">
                              {row?.remark}
                            </TableCell>
                            <TableCell
                              className="body-cell-end"
                              align="right"
                              width="10%"
                            >
                              <SupplierAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
